import { clientAPI } from '../configs/configs'
import { removeEmptyFields } from '../helpers/normalizers/removeEmptyFields'
import getMarCodigo from '@/helpers/functions/getMarCodigo'
import store from '../store'
const urlBase = '/returns'
export default class Orders {
  static async loadOrders(filters) {
    const brand = store.getters['brand/getBrand'] || {}
    const defaultFilters = {
      limit: null,
      offset: null,
      mar_codigo: getMarCodigo(brand?.id)      
    }
    const requestBody = Object.assign({}, defaultFilters, filters)
    return new Promise((res, rej) => {
      try {
        clientAPI.post(`${urlBase}/orders`, requestBody).then((response) => {
          res(response.data)
        })
      } catch (err) {
        rej(err)
      }
    })
  }

  static async getBonus(filters) {
    let defaultFilters = {
      bonCodigo: '',
      bonPercentual: '',
      bonStatus: '' 
    }

    let requestFilters = Object.assign({}, defaultFilters, filters)
    requestFilters = removeEmptyFields(requestFilters)
    
    const request_query_string = new URLSearchParams(requestFilters)
    
    return new Promise((res, rej) => {
     
      clientAPI
        .get(`${urlBase}/bonus`, {params: request_query_string})
        .then((response) => {
          res(response.data)
        })
        .catch((error) => {
          rej(error)
        })
     
    })
  } 
  static async getOccurrences(filters) {
    let defaultFilters = {
      ped_empresa: '',
      ped_filial: '',
      fat_sequencia: '' 
    }

    let requestFilters = Object.assign({}, defaultFilters, filters)
    requestFilters = removeEmptyFields(requestFilters)
    
    const request_query_string = new URLSearchParams(requestFilters)
    
    return new Promise((res, rej) => {
     
      clientAPI
        .get(`${urlBase}/occurrences/b2c`, {params: request_query_string})
        .then((response) => {
          res(response.data)
        })
        .catch((error) => {
          rej(error)
        })
     
    })
  } 
  static async getPhotographCollection(filters) {
    let defaultFilters = {
      emp_codigo: '',
      fil_codigo: '',
      fat_sequencia: '' 
    }

    let requestFilters = Object.assign({}, defaultFilters, filters)
    requestFilters = removeEmptyFields(requestFilters)
    
    const request_query_string = new URLSearchParams(requestFilters)
    
    return new Promise((res, rej) => {
     
      clientAPI
        .get(`${urlBase}/protocols/photograph-collection`, {params: request_query_string})
        .then((response) => {
          res(response.data)
        })
        .catch((error) => {
          rej(error)
        })
     
    })
  } 
}
